import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReportsFilter } from '../_model/reports-filter.model';
import { Filter } from 'src/app/user-management/_model/filter.model';
import Pusher from 'pusher-js';


@Injectable({
    providedIn: 'root'
})

export class DashboardService {
    token = localStorage.getItem('token');
    options = {
        headers: new HttpHeaders({
            // tslint:disable-next-line:object-literal-key-quotes
            'Authorization': `Bearer ${this.token}`
        })
    };
    pusher: any

    constructor(private http: HttpClient) {
        this.pusher = new Pusher(environment.PUSHER_API_KEY, {
            cluster: environment.PUSHER_API_CLUSTER,
            forceTLS: true
        });
    }

    subScribeToChannel(channelName: String, event: String, cb: Function) {
        this.pusher.unsubscribe(channelName);
        var channel = this.pusher.subscribe(channelName);

        channel.bind(event, function (data) {
            cb(data)
        });
    }
    
    private _initFilter = new Subject<boolean>();
    initFilter = this._initFilter.asObservable();

    setInitFilter() {
        this._initFilter.next(true);
    }

    getInitFilter() {
        return this._initFilter;
    }


    private _reportFilter = new Subject<ReportsFilter>();
    reportFilter = this._reportFilter.asObservable();

    setReportFilter(filter: ReportsFilter) {
        this._reportFilter.next(filter);
    }

    getReportFilter() {
        return this._reportFilter;
    }
    private _dateRangeValue =[];
    private _dateRange = new Subject<any>();
    dateRange = this._dateRange.asObservable();

    setRangeDate(date: any) {
        this._dateRange.next(date);
        this._dateRangeValue=date;
    }

    
    getRangeDate() {
        return this._dateRange;
    }
    getRangeDateValue() {
        return this._dateRangeValue;
    }


    private _reportType = new BehaviorSubject<string>('week');
    reportType = this._reportType.asObservable();

    setReportType(type) {
        this._reportType.next(type);
    }

    getReportType() {
        return this._reportType;
    }

    private _modalData = new BehaviorSubject<any>(null);
    modalData = this._modalData.asObservable();

    setModalData(data) {
        this._modalData.next(data);
    }

    getModalData() {
        return this._modalData;
    }

    private _download = new BehaviorSubject<boolean>(false);
    download = this._download.asObservable();

    setDownloadData(con) {
        this._download.next(con);
    }

    getDownloadData() {
        return this._download;
    }



    getBusesReport() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/bus`);
    }

    getDismissalAverageReport(date) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/average?to_date=${date}`)
    }

    getDismissalTrackingStatistics(date) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/tracking?to_date=${date}`)
    }

    getDismissalTrackingStudents(grade_id, class_id) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/tracking/students?filter[grade_id]=${grade_id}&filter[class_id]=${class_id}`)
    }

    getDismisssalTrackingStaff() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/tracking/staff`)
    }
    getDismisssalTrackingGrades() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/tracking/grades`)
    }
    getDismissalStatisticsReport(date) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/statistics?to_date=${date}`)
    }

    getAttendanceReport(date) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/attendance?to_date=${date}`)
    }

    getPickupReport(date, pickupType) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/pickup?to_date=${date}&filter[period]=${pickupType}`);
    }

    getUsersPickupReport(date, pickupType) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/users_pickup?to_date=${date}&filter[period]=${pickupType}`);
    }

    getUsersUsingStatus(date, pickupType) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/v2/users/group-by-dismissal-usage?to_date=${date}&filter[period]=${pickupType}`);
    }
    getNotUsingIds(date) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/v2/users/not-using-dismissal?date=${date}`);
    }

    getDismissalStudentsFlowReport(filter: ReportsFilter,pageNo) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/students/flow?from_date=${filter.fromDate}
        &to_date=${filter.toDate}
        ${filter.grade? filter.grade['name'] !== undefined ? `&filter[grade_id]=${filter.grade['id']}` : '':''}   
        ${filter.clazz? filter.clazz['name'] !== undefined ? `&filter[class_id]=${filter.clazz['id']}` : '':''}
        ${filter.search !== undefined ? `&search=${filter.search}` : ''}
        ${filter.dismissalStatus !== undefined ? `&dismissal[status]=${filter.dismissalStatus}` : ''}
        ${filter.dismissalType !== undefined ? `&dismissal[type]=${filter.dismissalType}` : ''}
        ${filter.requestedBy !== undefined ? `&filter[requested_by]=${filter.requestedBy}` : ''}
        &page=${pageNo}`
        )
    }
    generateExcelFile(filter: ReportsFilter) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/students/flow/export?from_date=${filter.fromDate}
        &to_date=${filter.toDate}
        ${filter.grade? filter.grade['name'] !== undefined ? `&filter[grade_id]=${filter.grade['id']}` : '':''}    
        ${filter.clazz? filter.clazz['name'] !== undefined ? `&filter[class_id]=${filter.clazz['id']}` : '':''}
        ${filter.search !== undefined ? `&search=${filter.search}` : ''}
        ${filter.dismissalStatus !== undefined ? `&dismissal[status]=${filter.dismissalStatus}` : ''}
        ${filter.dismissalType !== undefined ? `&dismissal[type]=${filter.dismissalType}` : ''}`
        )
    }

    generateAttendanceExcelFile(filter: ReportsFilter , period) {
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        let filterValuesForAttendanceApi = '';
        if (filter.grades !== undefined) {
            filter.grades.map((filterValue: string) => {
                filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue['id'])
            })
        }
        if (filter.classes !== undefined) {
            filter.classes.map((filterValue: string) => {
                filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue['id'])
            })
        }
        if (filter.attendance !== undefined) {
            filter.attendance.map((filterValue: string) => {
                filterValuesForAttendanceApi = filterValuesForAttendanceApi.concat('&filter[status][]=' + filterValue)
            })
        }        
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/attendance/students/export?from_date=${filter.fromDate}
        &to_date=${filter.toDate}
        &filter[period]=${period}
        ${filterValuesForGradesApi}
        ${filterValuesForClassesApi}
        ${filterValuesForAttendanceApi}
        ${filter.search !== undefined ? `&search=${filter.search}` : ''}`
        )
    }

    getStudentDismissalById(studentId:number,filter: ReportsFilter,pageNo,perPage){
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/students/${studentId}/flow?from_date=${filter.fromDate}
        &to_date=${filter.toDate}&page=${pageNo}&per_page=${perPage}
        ${filter.dismissalStatus !== undefined ? `&dismissal[status]=${filter.dismissalStatus}` : ''}
        ${filter.dismissalType !== undefined ? `&dismissal[type]=${filter.dismissalType}` : ''}`)
    }

    generateExcelFileById(studentId:number,filter: ReportsFilter){
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/students/${studentId}/flow/export?from_date=${filter.fromDate}
        &to_date=${filter.toDate} 
        ${filter.dismissalStatus !== undefined ? `&dismissal[status]=${filter.dismissalStatus}` : ''}
        ${filter.dismissalType !== undefined ? `&dismissal[type]=${filter.dismissalType}` : ''}
        `)
    }

    getDismissalStudentsFlowAverage(filter: ReportsFilter,pageNo) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/dismissal/students/average?from_date=${filter.fromDate}
        &to_date=${filter.toDate}
        ${filter.grade? filter.grade['name'] !== undefined ? `&filter[grade_id]=${filter.grade['id']}` : '':''}    
        ${filter.clazz? filter.clazz['name'] !== undefined ? `&filter[class_id]=${filter.clazz['id']}` : '':''}
        ${filter.search !== undefined ? `&search=${filter.search}` : ''}
        &page=${pageNo}`
        )
    }

    getAttendaceStudentsReport(filter: ReportsFilter, period , pageNo?) {  
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        let filterValuesForAttendanceApi = '';
        if (filter.grades !== undefined) {
            filter.grades.map((filterValue: string) => {
                filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue['id'])
            })
        }
        if (filter.classes !== undefined) {
            filter.classes.map((filterValue: string) => {
                filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue['id'])
            })
        }
        if (filter.attendance !== undefined) {
            filter.attendance.map((filterValue: string) => {
                filterValuesForAttendanceApi = filterValuesForAttendanceApi.concat('&filter[status][]=' + filterValue)
            })
        }        
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/attendance/students?from_date=${filter.fromDate}
        &to_date=${filter.toDate}
        &filter[period]=${period}
        ${filterValuesForGradesApi}
        ${filterValuesForClassesApi}
        ${filterValuesForAttendanceApi}
        ${filter.search !== undefined ? `&search=${filter.search}` : ''}
        ${pageNo? `&&page=${pageNo}` : ''}`
        )
    }
    // ${filter.grades !== undefined ? `&filter[grade_id][]=${filter.grades}` : ''}   
    // ${filter.classes !== undefined ? `&filter[class_id][]=${filter.classes}` : ''}
    // ${filter.grade !== undefined && filter.grade['id'] !== undefined ? `&filter[grade_id]=${filter.grade['id']}` : ''}   
    // ${filter.clazz !== undefined && filter.clazz['id'] !== undefined ? `&filter[class_id]=${filter.clazz['id']}` : ''}
    getDropdownDataBySearch(text){
    return this.http.get(environment.url + `v2/users/autocomplete?search=${text}`);
    }
    private _openFilter = new BehaviorSubject<boolean>(false);
    openFilter = this._openFilter.asObservable();

    toggleFilterStatus(filterStatus: boolean) {
        this._openFilter.next(filterStatus);
    }

    getFilterStatus() {
        return this._openFilter;
    }


    // to sent grades and classes from the control bar component to add modals instead of calling the api again
    private _setGrades = new BehaviorSubject<any>(null);
    setGrades = this._setGrades.asObservable();

    sentGrades(grades) {
        this._setGrades.next(grades);
    }

    getGrades() {
        return this._setGrades;
    }

    private _setClasses = new BehaviorSubject<any>(null);
    setClasses = this._setClasses.asObservable();

    sentClasses(classes) {
        this._setClasses.next(classes);
    }

    getClasses() {
        return this._setClasses;
    }

  

    getAllGrades() {        
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades`);
    }

    private _filterValue = new BehaviorSubject<Filter>(new Filter());
    filterValue = this._filterValue.asObservable();
    filterData = null;

    setFilterValue(value) {
        this._filterValue.next(value);
        this.filterData=value;
    }

    getFilterValue() {
        return this._filterValue;
    }

    private _filterFlag = new BehaviorSubject<any>(null);
    filterFlag = this._filterValue.asObservable();

    setFilterFlag(value) {
        this._filterFlag.next(value);
    }

    getFilterFlag() {
        return this._filterFlag;
    }
  
    private _closeFilter = new BehaviorSubject<any>(null);
    closeFilter = this._closeFilter.asObservable();


    closeFilterHandler() {
        this._closeFilter.next(false)
    }

    getCloseFilterHandler() {
        return this._closeFilter;
    }

    private _clearFilter = new BehaviorSubject<boolean>(false);
    clearFilter = this._clearFilter .asObservable();

    setClearFilter(bool) {
        this._clearFilter.next(bool);
    }

    getClearFilter() {
        return this._clearFilter;
    }

    private _studentData = new BehaviorSubject<Object>(null);
    studentData = this._studentData.asObservable();

    setStudentData(student, flag) {
        this._studentData.next({ 'student': student, 'flag': flag });
    }

    getStudentData() {
        return this._studentData;
    }
}